// extracted by mini-css-extract-plugin
module.exports = {"Container":"Grid_Container__VMtnw","Row":"Grid_Row__ZfvyD","Column":"Grid_Column__QTuGq","JC":"Grid_JC__oagnh","AT":"Grid_AT__2hBZw"};